export default __webpack_public_path__ + "static/S1-Animal-0175a263cbbded894f4cc0be30bfa61c.webp";